import * as moment from 'moment';
window.moment = moment;
const PersistenceManager = {
    retrieveStage() {
        //Used to restart checkout from the same stage when leaving the page
        if(sessionStorage.getItem('stage')) {
            return new Number(sessionStorage.getItem('stage')).valueOf();
        } else {
            return 1;
        }
    },
    setStage(stageNo) {
        // Persists the stage of checkout to session storage
        sessionStorage.setItem('stage', stageNo.toString());
    },
    setUserId(user_id) {
      sessionStorage.setItem('user_id', user_id);
    },
    retrieveUserId()
    {
        return sessionStorage.getItem('user_id');
    },
    holdServiceTypeInSession(serviceType)
    {
        sessionStorage.setItem('serviceType', serviceType);
    },
    holdCurbsideSms(curbside_sms)
    {
        sessionStorage.setItem('curbsideSmsNumber', curbside_sms);
    },
    retrieveCurbsideSms()
    {
        return sessionStorage.getItem('curbsideSmsNumber');
    },
    setCurbideOrderStatus(status)
    {
        if(status === 'true') {
            sessionStorage.setItem('isCurbsideOrder', 'true');
        }
        else {
            sessionStorage.setItem('isCurbsideOrder', 'false');
        }
    },
    isCurbsideOrder()
    {
        return sessionStorage.getItem('isCurbsideOrder') === 'true';
    },
    retrieveServiceType()
    {
        return sessionStorage.getItem('serviceType');
    },
    setAddressID(address_id) {
        // Persists the stage of checkout to session storage
        sessionStorage.setItem('address_id', address_id.toString());
    },
    retrieveAddressID() {
        //Used to restart checkout from the same stage when leaving the page
        if(sessionStorage.getItem('address_id')) {
            return parseInt(sessionStorage.getItem('address_id'));
        } else {
            return undefined;
        }
    },
    setCart(cart) {
        sessionStorage.setItem('sessionCart', cart);
    },
    retrieveCart() {
      return sessionStorage.getItem('sessionCart');
    },
    setDeferDateTime(datetime)
    {
        sessionStorage.setItem('deferDateTime', datetime);
    },
    setRawDeferDateTime(raw_datetime)
    {
        sessionStorage.setItem('rawDeferDateTime', raw_datetime);
    },
    retrieveRawDeferDateTime()
    {
        return new Date(sessionStorage.getItem('rawDeferDateTime'));
    },
    retrieveDeferDateTime()
    {
        return sessionStorage.getItem('deferDateTime');
    },
    setIsDeferredFalse()
    {
        sessionStorage.setItem('isDeferred', false);
    },
    setIsDeferredTrue()
    {
        sessionStorage.setItem('isDeferred', true);
    },
    isDeferDateSet()
    {
        return sessionStorage.getItem('isDeferred');
    },
    clearSession() {
        sessionStorage.clear();
    },
    setChosenMainItem(itemKey) {
        sessionStorage.setItem('chosenMainItem', itemKey.toString());
    },
    retrieveChosenMainItem() {
        return sessionStorage.getItem('chosenMainItem');
    },
    clearItemCustomization() {
        sessionStorage.removeItem('chosenMainItem');
    },
    setIsFutureOrder() {
        sessionStorage.setItem('isFutureOrder', 'true');
    },
    clearIsFutureOrder() {
        sessionStorage.removeItem('isFutureOrder');
    },
    setFutureOrderDate(date) {
        sessionStorage.setItem('futureOrderDate', date.format());
    },
    clearFutureOrderDate() {
        sessionStorage.removeItem('futureOrderDate');
    },
    setFutureOrderTime(time) {
        sessionStorage.setItem('futureOrderTime', time.format());
    },
    clearFutureOrderTime() {
        sessionStorage.removeItem('futureOrderTime');
    },
    retrieveIsFutureOrder() {
        if(sessionStorage.getItem('isFutureOrder')) {
            return sessionStorage.getItem('isFutureOrder');
        }else {
            return false
        }
    },
    retrieveFutureOrderTime() {
        if(sessionStorage.getItem('futureOrderTime')) {
            let time = sessionStorage.getItem('futureOrderTime');
            return moment(time);
        }else {
            return false
        }
    },
    retrieveFutureOrderDate() {
        if(sessionStorage.getItem('futureOrderDate')) {
            let date = sessionStorage.getItem('futureOrderDate');
            return moment(date);
        }else {
            return false
        }
    },
    setPaymentType(pmtType) {
        sessionStorage.setItem('paymentType', pmtType);
    },
    clearPaymentType() {
        sessionStorage.removeItem('paymentType');
    },
    retrievePaymentType() {
        if(sessionStorage.getItem('paymentType')) {
            return sessionStorage.getItem('paymentType');
        }else {
            return 'none'
        }
    },
    setS4Token(theToken) {
        sessionStorage.setItem('s4Token', theToken);
    },
    setS4Invoice(theInvoice) {
        sessionStorage.setItem('s4Invoice', theInvoice);
    },
    retrieveS4Token() {
        return sessionStorage.getItem('s4Token');
    },
    retrieveS4Invoice() {
        return sessionStorage.getItem('s4Invoice');
    },
    setUserRewardsInfo(rewardsInfo) {
        sessionStorage.setItem('$pointsToNextOffer', rewardsInfo);
    },
    getUserRewardsInfo() {
        return sessionStorage.getItem('$pointsToNextOffer');
    },
    clearUserRewardsInfo() {
        sessionStorage.removeItem('$pointsToNextOffer');
    },
}

export default PersistenceManager;